<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h2 mat-dialog-title>{{ "common.reportCameraIssue" | t }}</h2>
  <mat-dialog-content class="mat-typography">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="danger" type="button" (click)="cancel()">{{ "common.cancel" | t }}</button>
    <button mat-button [disabled]="form.invalid" type="submit" color="success">{{ "common.submit" | t }}</button>
  </mat-dialog-actions>
</form>
